module.exports = __webpack_public_path__ + "img/9788971997079.7dc01563.jpg";